import { render, staticRenderFns } from "./VRDevelopment.vue?vue&type=template&id=db6bc152&"
import script from "./VRDevelopment.vue?vue&type=script&lang=js&"
export * from "./VRDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports